import { IFont } from '@quicktools/shared-components/data/fonts';

export default function getFontFontId(font: IFont) {
  return `f${font.id}`;
}
